// extracted by mini-css-extract-plugin
export default {"myCarrierItemContainer":"style_myCarrierItemContainer__MmUIb"};